import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import "./installerDetails.styl";
import {InstallerDetail} from "../../../models/installer";
import {LanguageManager} from "../../../languages/languages";
import {ConfigService} from "../../../helpers/services/configService";
import {RouterManager, Routes} from "../../../router";
import {eventBus, signalNames} from "../../../bus";
import {application} from "../../../stores/application";
const template = require("./installerDetails.vue");

@Component({
  template: template
})
export class InstallerDetailsComponent extends Vue {

  installer: InstallerDetail = null;


  headers = [
    { text: LanguageManager.instance.i18n.t("userName"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("userEmail"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationName"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUuid"), align: "left", sortable: false }
  ];

  created(): void {
    this.refreshInstaller();
  }

  refreshInstaller() {
    this.installer = null;
    application.commitStartLoader(this.$store);
    Vue.http.get(ConfigService.automations + "/installer_info/?email=" + this.$route.query.email, {})
      .then(response => {
        this.installer = new InstallerDetail().deserialize(response.data.data);
        let title = this.installer.name ? this.installer.name : "Utente installatore";
        eventBus.$emit(signalNames.setToolbarOptions, {
          title: title + " - automazioni installate: \" " + this.installer.automations.length + " \" ",
          backAction: () => RouterManager.instance.router.push(Routes.installers),
          reloadAction: () => this.refreshInstaller()
        });
        console.log("installer details:", this.installer);
        application.commitStopLoader(this.$store);
      })
      .catch(error => {
        application.commitStopLoader(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }

  handleClickAutomation(automationId) {
    this.$router.push({name: Routes.automationDetail.name,  params: { id: automationId }});
  }

}

Vue.component("cmInstallerDetails", InstallerDetailsComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/installerDetails/installerDetails.ts